import React from "react"
import styled from "styled-components"

import {customRewardThumbnail} from "./Search"

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`

const StyledImg = styled.img`
  ${({size}) => `
    height: ${size}px;
    width: ${size}px;
  `}
  margin-right: 10px;
`

const RewardRow = (reward) => {
  const img = reward.img || customRewardThumbnail
  return (
    <FlexRow>
      <StyledImg src={img} size={24} />
      <div>{reward.alt}</div>
    </FlexRow>
  )
}

export default RewardRow
